import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import { Divider } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import DrawIcon from '@mui/icons-material/Draw';
import { useNavigate } from 'react-router-dom';
import { ROUTE_OLDPAPER } from '../utils';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

export default function Header({value}) {
  const navigate = useNavigate();
const [language,setLenguage] = React.useState(true);
const [header,setHeader] = React.useState(false);
const matches = useMediaQuery('(min-width:1000px)');

function changeLanguage(){
    setLenguage(!language ? true : false);      
};
const headerColor = () =>{
      setHeader(true)
};
const headerLeaveColor = () =>{
  setHeader(false)
};
function setContact(e){
  navigate(e)
};

  return (
    <Box onMouseEnter ={headerColor} onMouseLeave={headerLeaveColor} sx={header?{backgroundColor:'#345C9B'} :''}>
       
        <Box  sx={{width:1600,display:'flex',justifyContent:'space-between',alignItems:'center',maxWidth:'100%',marginLeft:'auto',marginRight:'auto',minHeight:'80px'}}>
        
     
          <DrawIcon sx={{color:'white',marginLeft:'20px'}} onClick={()=>setContact(ROUTE_OLDPAPER)}/>
          <Typography
            variant="h6"
            noWrap
            color='white'
            component="div"
            sx={{ flexGrow: 1,justifyContent:'center',cursor:'pointer',marginLeft:'20px' }}
            
          >
           {/* <Link to='/oldpaper'>webdesign.pro</Link>  */}
          </Typography>
          
         <Box sx={{cursor:'pointer',background:'#346C9B', width:'40px',height:'40px',display:'flex',alignItems:'center',borderRadius:'20px',marginRight:'30px'}}>
            <Typography color='secondary' sx={{marginRight:2, marginLeft:'auto', marginRight:'auto'}} onClick={()=>{
                changeLanguage();
                value(language);
                }}>{language ? 'EN' :'RU'}</Typography>
</Box>
      
        </Box>
      
      <Divider  color="#1D6FF2" flexItem />
    </Box>
   
  );
}